<template>
  <div class="content-box">
    <div class="element-wrapper" style="background-color: white;">
      <div class="element-box">
        <div class="row d-flex justify-content-between">
          <div>
            <h5 class="form-header">Asignación de Tarea Usuario</h5>
          </div>
          <div>
            <div class="btn-group dropleft">
              <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-cogs"></i>&nbsp;Acciones
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <router-link class="dropdown-item" :to="{ name: 'wms-tarea-usuario-nuevo' }">
                  <i class="fas fa-plus"></i>&nbsp;Asignar Nuevo Usuario
                </router-link>
                <router-link class="dropdown-item" :to="{ name: 'wms-tarea-usuario-editar-tareas' }">
                  <i class="fas fa-edit"></i>&nbsp; Editar Categorias y Sub Categorias por Usuario
                </router-link>
                <router-link class="dropdown-item" :to="{ name: 'wms-tarea-usuario-asignar-tareas' }">
                  <i class="fas fa-clone"></i>&nbsp;Clonar Categorías y Sub Categorías a usuario Nuevo
                </router-link>
                <button class="dropdown-item" @click="ModalCambiarTipoTarea">
                  <i class="fa fa-sync"></i>&nbsp;Cambiar Tipo Tarea Usuario
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <CambiarTipoTareaModalComponent @refreshData="filterData()" />
            <div class="col-sm-12">
              <br />
              <div class="form-inline justify-content-sm-end">
                <select class="form-control form-control-sm rounded bright" v-model="filter.estado_str"
                  @change="filterData()">
                  <option value>Todos</option>
                  <option :value="true">Activo</option>
                  <option :value="false">Inactivo</option>
                </select>
                <SubCategoriaSelectComponent class="col-sm-2" style="display: block" @change="filterData()" title=""
                  :current="filter" />
                <CategoriaSelectComponent class="col-sm-2" style="display: block" @change="filterData()" title=""
                  :current="filter" />
                <UsuariosSelectComponent class="col-sm-2" style="display: block" @onChange="filterData()" titulo=""
                  :current="filter" />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" @click="filterData()">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br><br>
        <TareaUsuarioTableComponent :dataTabla="dataTabla" />
      </div>

      <PaginationComponent :currentPage="currentPage" :data="dataTabla" @pagechanged="filterData" />
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import CategoriaSelectComponent from "@/components/commons/CategoriaSelectComponent ";
import SubCategoriaSelectComponent from "@/components/commons/SubCategoriaSelectComponent ";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import TareaUsuarioTableComponent from "@/components/wms/utilidades/Asignar_tarea_usuario/TareaUsuarioTableComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";
import CambiarTipoTareaModalComponent from "@/components/wms/utilidades/Asignar_tarea_usuario/CambiarTipoTareaModalComponent";
import CategoriasUsuarioEdicionComponent from "@/components/wms/utilidades/Asignar_tarea_usuario/CategoriasUsuarioEdicionComponent";

export default {
  components: {
    TareaUsuarioTableComponent,
    UsuariosSelectComponent,
    CategoriaSelectComponent,
    SubCategoriaSelectComponent,
    UsuarioEnTablaComponent,
    PaginationComponent,
    CambiarTipoTareaModalComponent,
    CategoriasUsuarioEdicionComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      dataTabla: "",
      filter: {
        tienda: "",
        estado_str: "",
        searchtext: "",
        usuario: "",
        proveedor: "",
        fecha: "",
        categoria: "",
        subcategoria: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.filterData();
  },
  methods: {
    ModalCambiarTipoTarea() {
      let self = this;
      $("#cambiarTipoTareaGlobal").modal("show");
    },
    filterData(page) {
      let self = this;
      if (!page) {
        page = 1;
      }
      if (self.filter.usuario == null) {
        self.filter.usuario = "";
      }
      if (self.filter.categoria == null) {
        self.filter.categoria = "";
      }
      if (self.filter.subcategoria == null) {
        self.filter.subcategoria = "";
      }
      self.currentPage = page;
      DynamicService.fetch("wms", "asignar-tarea-usuario", {
        estatus: self.filter.estado_str,
        tienda_destino: self.filter.tienda,
        pickeador: self.filter.usuario.id,
        categoria: self.filter.categoria.codigo,
        sub_categoria: self.filter.subcategoria.codigo,
        page: page,
      }).then((response) => {
        self.dataTabla = response.data;
      });
    },
    clearFilterData() {
      this.filter.estado_str = "";
      this.$data.currentPage = 1;
      this.filter.tienda = "";
      this.filter.usuario = "";
      this.filter.categoria = "";
      this.filter.subcategoria = "";
      DynamicService.fetch("wms", "asignar-tarea-usuario").then((response) => {
        this.dataTabla = response.data;
      });
    },
  },
};
</script>
